"use strict";

exports.__esModule = !0, exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base")),
    _react = _interopRequireWildcard(require("react")),
    _util = require("../util"),
    PropTypes = _interopRequireWildcard(require("prop-types")),
    _constants = require("../constants");

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function () {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" != typeof a && "function" != typeof a) return {
    default: a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) if (Object.prototype.hasOwnProperty.call(a, e)) {
    var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
    f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
  }

  return c.default = a, b && b.set(a, c), c;
}

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _assertThisInitialized(a) {
  if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}

function _inheritsLoose(a, b) {
  a.prototype = Object.create(b.prototype), a.prototype.constructor = a, a.__proto__ = b;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var Item = /*#__PURE__*/function (a) {
  function b() {
    for (var b, c = arguments.length, d = Array(c), e = 0; e < c; e++) d[e] = arguments[e];

    return b = a.call.apply(a, [this].concat(d)) || this, _defineProperty(_assertThisInitialized(b), "item", _react.default.createRef()), b;
  }

  _inheritsLoose(b, a);

  var c = b.prototype;
  return c.componentDidMount = function componentDidMount() {
    var a = this.props,
        b = a.props,
        c = a.methods;
    !b.multi && b.keepSelectedInList && c.isSelected(this.props.item) && this.item.current.scrollIntoView({
      block: "nearest",
      inline: "start"
    });
  }, c.componentDidUpdate = function componentDidUpdate() {
    this.props.state.cursor === this.props.itemIndex && this.item.current && this.item.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    });
  }, c.render = function render() {
    var a = this.props,
        b = a.props,
        c = a.state,
        d = a.methods,
        e = a.item,
        f = a.itemIndex;
    return b.itemRenderer ? b.itemRenderer({
      item: e,
      itemIndex: f,
      props: b,
      state: c,
      methods: d
    }) : !b.keepSelectedInList && d.isSelected(e) ? null : _react.default.createElement(ItemComponent, {
      role: "option",
      ref: this.item,
      "aria-selected": d.isSelected(e),
      "aria-disabled": e.disabled,
      "aria-label": (0, _util.getByPath)(e, b.labelField),
      disabled: e.disabled,
      key: "" + (0, _util.getByPath)(e, b.valueField) + (0, _util.getByPath)(e, b.labelField),
      tabIndex: "-1",
      className: _constants.LIB_NAME + "-item " + (d.isSelected(e) ? _constants.LIB_NAME + "-item-selected" : "") + " " + (c.cursor === f ? _constants.LIB_NAME + "-item-active" : "") + " " + (e.disabled ? _constants.LIB_NAME + "-item-disabled" : ""),
      onClick: e.disabled ? void 0 : function () {
        return d.addItem(e);
      },
      onKeyPress: e.disabled ? void 0 : function () {
        return d.addItem(e);
      },
      color: b.color
    }, (0, _util.getByPath)(e, b.labelField), " ", e.disabled && _react.default.createElement("ins", null, b.disabledLabel));
  }, b;
}(_react.Component),
    ItemComponent = (0, _styledBase.default)("span", {
  target: "evc32pp0",
  label: "ItemComponent"
})("padding:5px 10px;cursor:pointer;border-bottom:1px solid #fff;&.", _constants.LIB_NAME, "-item-active{border-bottom:1px solid #fff;", function (a) {
  var b = a.disabled,
      c = a.color;
  return !b && c && "background: " + (0, _util.hexToRGBA)(c, .1) + ";";
}, "}:hover,:focus{background:", function (a) {
  var b = a.color;
  return b && (0, _util.hexToRGBA)(b, .1);
}, ";outline:none;}&.", _constants.LIB_NAME, "-item-selected{", function (a) {
  var b = a.disabled,
      c = a.color;
  return b ? "\n    background: #f2f2f2;\n    color: #ccc;\n    " : "\n    background: " + c + ";\n    color: #fff;\n    border-bottom: 1px solid #fff;\n    ";
}, "}", function (a) {
  var b = a.disabled;
  return b ? "\n    background: #f2f2f2;\n    color: #ccc;\n\n    ins {\n      text-decoration: none;\n      border:1px solid #ccc;\n      border-radius: 2px;\n      padding: 0px 3px;\n      font-size: x-small;\n      text-transform: uppercase;\n    }\n    " : "";
}, "production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    _default = Item;

exports.default = _default;